<script lang="ts">
    import LoadMoreButton from "@apps/iloom_customization/components/LoadMoreButton.svelte";
    import Pagination from "@apps/iloom_customization/components/Pagination.svelte";
    import DesignFeedMasonry from "@apps/iloom_customization/design_feed/components/DesignFeedMasonry.svelte";
    import { MediaListQuery } from "@apps/iloom_customization/design_feed/queries/MediaListQuery";
    import { DesignFeedService } from "@apps/iloom_customization/design_feed/services/DesignFeedService";
    import { MEDIA_LIST_LIMIT } from "@apps/iloom_customization/design_feed/stores/MediaListStore";
    import { BehaviorSubject, lastValueFrom } from "rxjs";
    import { onMount } from "svelte";

    import { ModalManager } from "@components/Modal/ModalManager";

    export let designFeedService: DesignFeedService;
    export let mediaListQuery: MediaListQuery;
    export let modalManager: ModalManager;

    const isMobile = window.innerWidth <= 600;

    const meta$ = mediaListQuery.meta$;
    const loadMoreStatus$ = mediaListQuery.loadMoreStatus$;

    const page$ = new BehaviorSubject<number>(1);

    const handleChangePage = (event: CustomEvent) => page$.next(event.detail);

    const getMediaList = (offset = 0) => {
        const params = {
            offset,
            limit: MEDIA_LIST_LIMIT,
        };
        lastValueFrom(designFeedService.getCustomerMediaList(params, isMobile));
    };

    onMount(() => {
        const changePageSubscription = page$.subscribe((value) => {
            getMediaList((value - 1) * MEDIA_LIST_LIMIT);
        });

        return () => {
            changePageSubscription.unsubscribe();
        };
    });
</script>

<div class="gw-cwl-media-list-divider" />

<DesignFeedMasonry
    {mediaListQuery}
    {designFeedService}
    {modalManager}
    withLoadMore={false}
/>

<div class="gw-cwl-media-list-space" />

{#if isMobile}
    <LoadMoreButton
        meta={$meta$}
        loadMoreStatus={$loadMoreStatus$}
        loadMore={getMediaList}
    />
{:else}
    <Pagination meta={$meta$} on:changePage={handleChangePage} />
{/if}

<style lang="postcss">
    .gw-cwl-media-list-divider {
        margin-top: 100px;
        margin-bottom: 48px;
        border-bottom: 1px dashed #bebebe;
    }
    .gw-cwl-media-list-space {
        margin-bottom: 100px;
    }
    @media all and (max-width: 600px) {
        .gw-cwl-media-list-divider {
            margin-top: 68px;
            margin-bottom: 0;
            border-bottom: none;
        }
        .gw-cwl-media-list-space {
            margin-bottom: 40px;
        }
    }
</style>
